module.exports = __webpack_public_path__ + "img/logo_slogan.93509e4b.png";